export default __webpack_public_path__ + "static/media/logo-on-top.0b51283e.svg";